var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        slot: "reference",
        content: _vm.itemText,
        placement: "bottom",
        contentClass: "navbar-tooltip",
        arrow: false,
        disabled: _vm.isDisableTooltip
      },
      slot: "reference"
    },
    [
      _c(
        "a",
        {
          staticClass: "navbar-content__actions--item-link",
          class: _vm.itemClass,
          attrs: { href: _vm.itemUrl }
        },
        [
          _vm.isNew
            ? _c("CompassFlag", {
                staticClass: "navbar-content__actions--item-link-flag",
                attrs: { label: "New", size: "small" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.useFaIcon
            ? _c("i", {
                staticClass: "fa navbar-content__actions--item-icon",
                class: _vm.itemIcon
              })
            : _c("CompassIcon", {
                staticClass: "navbar-content__actions--item-icon",
                attrs: { icon: _vm.itemIcon }
              }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "navbar-content__actions--item-label typographies-paragraph-small-regular"
            },
            [_vm._v("\n            " + _vm._s(_vm.itemText) + "\n        ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }